import DateRange from '../global/comp/DateRange';
import { useGetAdminDashboardStatsQuery } from '../../slices/usersApiSlice';
import { useSelector } from "react-redux";
import "../css/Dashboard.css"
import { Badge, Breadcrumb, Button, Card, Col, Divider, Grid, notification, Popover, Row, Space, Spin, Statistic, Typography } from 'antd';
import { useNavigate } from "react-router-dom";
import { ArrowDownOutlined, ArrowUpOutlined, BorderBottomOutlined, DashboardOutlined, DownOutlined, FileAddOutlined, ImportOutlined, InfoCircleTwoTone, LockOutlined, RightOutlined, SyncOutlined, UploadOutlined } from '@ant-design/icons';
import TotalSaleScreen from "../TotalSaleScreen";
import axios from 'axios'
import { useState, useEffect } from 'react';
import { useGetweeklysalesQuery } from '../../slices/paymentApiSlice';
import VisitCounter from '../Usercomp/VisitCounter';
import { useGetVisitCounterQuery } from '../../slices/visitApiSlice';


const { Title, Text } = Typography;

const AdminDashboardScreen = () => {

  const { data: dashboardData, isLoading: dashboardLoading, error: dashboardError } = useGetAdminDashboardStatsQuery();
  const { data: weeklysales, isLoading: weeklySalesLoading, error: weeklySalesError, isSuccess } = useGetweeklysalesQuery();
  console.log("weeklydata", weeklysales);
  const { data: visitcounter, isLoading, isError } = useGetVisitCounterQuery();
  console.log(visitcounter, "visitor");

  console.log("count", visitcounter);

  const [visitCount, setVisitCount] = useState('');

  useEffect(() => {
    if (visitcounter && visitcounter.totalVisitors !== undefined) {
      setVisitCount(visitcounter.totalVisitors);
    }

  }, [visitcounter]);
  const { darkmode } = useSelector((state) => state.darkmode);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const newDate = new Date();
  const navigate = useNavigate();

  const [weeklySalesData, setWeeklySalesData] = useState(null);

  useEffect(() => {
    if (isSuccess) {
      setWeeklySalesData(weeklysales);
      console.log(weeklySalesData);
    }
  }, [isSuccess]);



  if (dashboardLoading) return <p>Loading...</p>;
  if (dashboardError) return <p>Error loading data</p>;





  if (isLoading) {
    return (
      <Card title="Website Visits Count" >
        <Text>Loading...</Text>
      </Card>
    );
  }

  if (isError) {
    return (
      <Card title="Website Visits Count" >
        <Text type="danger">Error fetching data.</Text>
      </Card>
    );
  }

  return (
    <div>
      <Title style={{    fontFamily: 'Inter, sans-serif',}}  level={2}><DashboardOutlined /> &nbsp;Admin Dashboard</Title>

      <Row style={{ padding: "20px", backgroundColor: darkmode ? "#141414" : "#FFF", borderRadius: "5px" }}>
        <Col flex={"auto"}>
          <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Admin Dashboard' }]} style={{ marginBottom: "5px" }} />
          <Space direction="horizontal" style={{ marginBottom: "10px" }}>
            {!screens.lg ? (<DateRange />) : (<></>)}
          </Space>
        </Col>
        <Col flex={"none"}>
          <Space direction={!screens.lg ? "vertical" : "horizontal"} style={{ marginBottom: "10px" }}>
            <Text type="secondary"><SyncOutlined /> Last import was: {newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()}</Text>
            <Button type='primary' onClick={e => navigate('/ImportTrades')} ghost><ImportOutlined /> Import Trades</Button>
          </Space>
        </Col>
      </Row>
      <Divider />



      <Row gutter={[20, 24]} style={{ marginBottom: "10px" }}>
        <Col md={6} xs={24}>
          <Card bordered={false} className='card_hover' style={{ borderBottom: "2px solid #2980b9" }} >
            <Statistic
              title={"Total Users"}
              value={dashboardData?.totalUsers}
              prefix={<ArrowDownOutlined style={{ color: "#c0392b" }} />}
              valueStyle={{ color: "#1677ff", fontSize: "16px" }}
            />
          </Card>
        </Col>

        <Col md={4} xs={24}>
          <Card bordered={false} className='card_hover' style={{ borderBottom: "2px solid #2980b9" }} >
            <Statistic
              title={"Total Subscribers"}
              value={dashboardData?.totalSubscribers}
              prefix={<ArrowDownOutlined style={{ color: "#c0392b" }} />}
              valueStyle={{ color: "#1677ff", fontSize: "16px" }}
            />
          </Card>
        </Col>

        <Col md={4} xs={24}>
          <Card bordered={false} className='card_hover' style={{ borderBottom: "2px solid #2980b9" }} >
            <Statistic
              title={"Total Revenue"}
      value={dashboardData?.totalRevenue ? dashboardData.totalRevenue / 100 : 0}
              prefix={<> <ArrowDownOutlined style={{ color: "#c0392b" }} /> ₹ </>}
              valueStyle={{ color: "#1677ff", fontSize: "16px" }}
            />
          </Card>
        </Col>
        <Col md={4} xs={24}>

          <Card bordered={false} className='card_hover' style={{ borderBottom: "2px solid #2980b9" }} >
            <Statistic
              title={"Website visit count"}
              value={visitcounter?.totalVisitors}
              prefix={<> <ArrowDownOutlined style={{ color: "#c0392b" }} />  </>}
              valueStyle={{ color: "#1677ff", fontSize: "16px" }}
            />
          </Card>
        </Col>

        <Col md={6} xs={24}>
          <Card bordered={false} className='card_hover' style={{ borderBottom: "2px solid #2980b9" }} >
            <Statistic
              title={"This Week Revenue"}
              // value={weeklySalesData?.weeklySales ?? 0}
                value={weeklySalesData?.weeklySales ? weeklySalesData.weeklySales / 100 : 0}

              prefix={<> <ArrowDownOutlined style={{ color: "#c0392b" }} /> ₹ </>}
              valueStyle={{ color: "#1677ff", fontSize: "16px" }}
            />
          </Card>
        </Col>
      </Row>

      <TotalSaleScreen />



      <Row gutter={[16, 24]}>
        <Col md={12} xs={24}>




        </Col>
        <Col md={10} xs={24}>
          {/* <Card title="pie chart" loading={false} bordered={false} className='card_hover'>
              
            </Card> */}
        </Col>
        <Col md={8} xs={24}>

        </Col>
      </Row>


    </div>

  );
};

export default AdminDashboardScreen;
